module.exports = __webpack_public_path__ + "static/media/record-vinyl.2120f742.svg";